/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'
import coreSchemas from './core/entities/index.js'
import { baseEntitySchema } from './core/entity.js'
import { storageSchema } from './core/index.js'
import type { CoreElement } from './core/slate/slate-element.js'
import { entityTypeNames } from './entity-types.js'
import { extensionSchemas } from './extensions/index.js'

/** Schemas  */
export const schemas = {
  /* * @todo implement these */
  section: baseEntitySchema.extend({ type: z.literal('section') }).loose(),
  sketch: baseEntitySchema.extend({ type: z.literal('sketch') }).loose(),
  amp: baseEntitySchema.extend({ type: z.literal('amp') }).loose(),
  bass: baseEntitySchema.extend({ type: z.literal('bass') }).loose(),
  event: baseEntitySchema.extend({ type: z.literal('event') }).loose(),
  drawing: baseEntitySchema.extend({ type: z.literal('drawing') }).loose(),
  drums: baseEntitySchema.extend({ type: z.literal('drums') }).loose(),
  facade: baseEntitySchema.extend({ type: z.literal('facade') }).loose(),
  guitar: baseEntitySchema.extend({ type: z.literal('guitar') }).loose(),
  mic: baseEntitySchema.extend({ type: z.literal('mic') }).loose(),
  piano: baseEntitySchema.extend({ type: z.literal('piano') }).loose(),
  playlist: baseEntitySchema.extend({ type: z.literal('playlist') }).loose(),
  room: baseEntitySchema.extend({ type: z.literal('room') }).loose(),
  score: baseEntitySchema.extend({ type: z.literal('score') }).loose(),
  tab: baseEntitySchema.extend({ type: z.literal('tab') }).loose(),
  synth: baseEntitySchema.extend({ type: z.literal('synth') }).loose(),
  tracker: baseEntitySchema.extend({ type: z.literal('tracker') }).loose(),
  trackerdata: baseEntitySchema.extend({ type: z.literal('trackerdata') }).loose(),

  // Stored entities
  evernote: baseEntitySchema.extend({ type: z.literal('evernote'), storage: storageSchema }).loose(),

  /** Core schemas */
  ...coreSchemas,
  /** Extension schemas */
  ...extensionSchemas,
}

/** Full Schema that from `baseEntitySchema` that contains type field */
export const entitySchema = baseEntitySchema.extend({
  type: z.enum(entityTypeNames),
})

/** @todo move these out of this file */

/**
 * We have the following challenge. Some of the entities we want to be able to embed
 * in the slate editor (e.g., audio) others not (e.g., folder). So some of them
 * must be compatible with SlateElement, which means:
 *  1) index signature
 *  2) children
 *
 * We don't want to have an index signature on all of the entities for type safety.
 */
export type Entity = z.infer<typeof entitySchema>
export function isEntity<T>(node: T): node is Entity & T {
  return entitySchema.safeParse(node).success
}

export type TEntity<T> = Entity & T

/** @todo do we need this? */
export type EntityOrElement = CoreElement | Entity

/**
 * Schema used for eTag calculation. We don't include `storage/versionId` since it's managed out-of-band
 */
export const entityETagSchema = baseEntitySchema
  .extend({ storage: storageSchema.omit({ versionId: true }).optional() })
  .loose()
  // Ignore these fields for eTag calculation
  .transform(data => {
    const { lastEditedBy, version, versionAt, createdAt, updatedAt, ...restProps } = data
    return restProps
  })

export type EntityETag = z.infer<typeof entityETagSchema>
